import Vue from "vue";
declare var EDDocument: any;
export default {
    //actived page
    state: {
        pages: [], // page attr string [{}];{name:string,id:number}
        activedPageIndex: 0, // activedPageIndex
        isSaveSpecPage: false, // 保存左下角指定tab单页
        activedPageID: null, //activedPageID
        pageBackgroundColor: "", // page 背景色。
        isPageBg: false, // page 背景
        conLineType: 2, //默认连接线类型。eConLineType.RightAngle
        shapeCount: 0, // 文档(所有页面下的)总形状数
        activedThemeId: 0, //actived theme id.
        activedPageLayers: [], //actived page layers.
        pageUnitStr: "mm",
        showGrid: true, //refer to doc.config.showGrid
        showRuler: false, // refer to doc.config.showRuler
        showGuideline: false,
        showPageBreak: false,
        showLine: false,
        showSnapGrid: false,
        showSnapGuideline: false,
        showFloatBtn: true,
        showMargin: true,
        showMovecoordinate: false,
        isMMPage: false, // 当前页面是否包含mmshape
        isMMCenter: false, // 是否包含中心主题

        // 页面设置
        sizeType: 0,
        autoSize: false,
        preDefinedPaper: 0,
        pageUnit: 0, // pageUnit default: mm
        pageWidth: 0,
        pageHeight: 0,
        pagePxWidth: 0, // 页面像素宽度，未扩展页面前的值
        pagePxHeight: 0,
        isPortrait: false,
        jumpMode: 0, // None: 0,  Horizontal: 1,  Vertical: 2,
        jumpStyle: 0, // eJumpStyle
        pageNumStyle: 0,
        pageNumPosition: 0,
        timeDateType: 0,
        timeDateStyle: "yyyy-MM-dd",
        timeDatePosition: 4,

        // 网格设置
        gridFitRuler: true, // 网格适应标尺
        gridHSp: 1, // 网格水平间距
        gridHSub: 1, // 网格水平细分
        gridVSp: 1, // 网格垂直间距
        gridVSub: 1, // 网格垂直细分

        theme: {
            themeID: 0, // number
            clrThemeID: 0, // number
            cntThemeID: 0, // number
            effThemeID: 0, // number
            textThemeID: 0, //number
        },
        themesImageMap: {},
        themeConnectorsImageMap: {},
        quickStyleImageMap: [],
        tableQuickStyleImageMap: [],
        activeThemeImage: "",
        lockClrTheme: -1,
        lockCntTheme: -1,
        lockTextTheme: -1,
        expandList: ["pageSetting", "numSetting", "timeDateSeting", "pageFit", "gridSetting"],

        //主题默认样式
        ignoreDefFont: false,
        themeTextFamily: "",
        themeTextSize: 0,
        themeTextBold: false,
        themeTextItalic: false,
        themeTextUnderline: false,
        themeTextStrike: false,
        themeTextAlign: 0,
        themeTextLineHeight: 1,
        themeTextColor: "#000",
        themeTextBGColor: "",

        ignoreDefCnt: false,
        themeLineWidth: 0,
        themeBArrow: "",
        themeEArrow: "",
        themeRoundSize: 0,
        themeBSText: 3,
        themeESText: 3,
        themeLineStyle: "",
    },
    mutations: {
        setPageStat(state, payload) {
            state[payload.type] = payload.data;
        },
        setActivedPageIndex(state, payload) {
            state[payload.type] = payload.data;
        },
        setTheme(state, payload) {
            state.theme = payload;
            state.activedThemeId = payload.themeID;
        },
        setThemesImage(state, payload) {
            Vue.set(state.themesImageMap, payload.type, payload.data);
            // state.themesImageMap[payload.type] = payload.data;
        },
        setThemeConnectorsImage(state, payload) {
            Vue.set(state.themeConnectorsImageMap, payload.type, payload.data);
            // state.themeConnectorsImageMap[payload.type] = payload.data;
        },
        setQuickStyleImage(state, payload) {
            state.quickStyleImageMap = payload;
        },
        setTableQuickStyleImage(state, payload) {
            state.tableQuickStyleImageMap.splice(payload.type, 1, payload.data);
        },
    },
    getters: {
        themes: (state) => {
            return EDDocument.s_themeManager._themes;
        },
        colorThemes: (state) => {
            return EDDocument.s_themeManager._clrThemes;
        },
        connectorThemes: (state) => {
            return EDDocument.s_themeManager._cntThemes;
        },
        effectThemes: (state) => {
            return EDDocument.s_themeManager._effThemes;
        },
        textThemes: (state) => {
            return EDDocument.s_themeManager._textThemes;
        },
        mmTextThemes: (state) => {
            return EDDocument.s_themeManager._mmTxtThemes;
        },
        theme: (state) => {
            return EDDocument.s_themeManager.themeByID(state.theme.themeID);
        },
        colorTheme: (state) => {
            if (typeof EDDocument === "undefined") return;
            return EDDocument.s_themeManager.clrThemeByID(state.theme.clrThemeID);
        },
        connectorTheme: (state) => {
            return EDDocument.s_themeManager.cntThemeByID(state.theme.cntThemeID);
        },
        effectTheme: (state) => {
            return EDDocument.s_themeManager.effThemeByID(state.theme.effThemeID);
        },
        textTheme: (state) => {
            return EDDocument.s_themeManager.textThemeByID(state.theme.textThemeID);
        },
    },
};
